// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file financial/company_price_feed/entity/v2/indicative_price_volume.proto (package financial.company_price_feed.entity.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message financial.company_price_feed.entity.v2.IEPIEV
 */
export const IEPIEV = /*@__PURE__*/ proto3.makeMessageType(
  "financial.company_price_feed.entity.v2.IEPIEV",
  () => [
    { no: 1, name: "stock_code", jsonName: "stock_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "iep", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "iev", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "sequence_number", jsonName: "sequence_number", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "datetime", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

